import React, { useState } from 'react';
import styles from './GridTabFolding.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMale, faFemale, faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import AxiosConfig from "../../services/AxiosConfig";
import {getUtilisateurStatus, getUtilisateurStatusIcon, parseUtilisateurStatus} from "../../services/UserService";
import {useUser} from "../../contexts/UserContext";
import DateService from "../../services/DateService";
import {parseSeanceStatus} from "../../services/SeanceService";
import BtnSwitch from "../Button/BtnSwitch";
import stylesSwitch from "../Button/BtnSwitch.module.css";
import {Link} from "react-router-dom";
import Routing from "../../services/routing";


const GridTabFolding = ({ listData, columns }) => {
    const [expandedRows, setExpandedRows] = useState({});
    const [sortedColumn, setSortedColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const user = useUser();
    const [usersSeances, setUsersSeances] = useState({});

    const deleteSalarieByReferent = async (salarieId) => {
        const response = await AxiosConfig.post(`/user/delete/${salarieId}`, );
        return response.data;
    };

    const getSeancesForSalarie = async (salarieId) => {
        const response = await AxiosConfig.get(`/users/participants/${salarieId}/seances`);
        return response.data;
    }

    const toggleRow = (index) => {
        setExpandedRows(prevState => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };

    const handleSort = (columnName) => {
        const isAsc = sortedColumn === columnName && sortDirection === 'asc';
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortedColumn(columnName);
    };
    const sortedData = React.useMemo(() => {
        return [...listData].sort((a, b) => {
            if (a[sortedColumn] < b[sortedColumn]) {
                return sortDirection === 'asc' ? -1 : 1;
            }
            if (a[sortedColumn] > b[sortedColumn]) {
                return sortDirection === 'asc' ? 1 : -1;
            }
            return 0;
        });
    }, [listData, sortedColumn, sortDirection]);


    const columnWidths = `2fr ${'1fr '.repeat(columns.length - 1).trim()}`;

    return (
        <div className={styles.gridContainer} style={{gridTemplateColumns: columnWidths}}>
            <>
                {columns.map((column, index) => (
                    <div
                        key={index}
                        className={`${styles.cell} ${styles.columnHeader} ${column.field === 'name' ? styles.alignLeft : styles.alignCenter}`}
                        onClick={() => handleSort(column.field)}
                    >
                        {column.header}
                    </div>)
                )}
            </>

            {sortedData.map((item, index) => (
                <React.Fragment key={item.id}>
                    {columns.map((column, colIndex) => (
                        <div
                            key={colIndex}
                            className={`${styles.cell} ${column.field === 'name' ? styles.alignLeft : styles.alignCenter}`}
                            onClick={() => toggleRow(index)}
                            title={column.field === 'status' ? getUtilisateurStatus(item[column.field]) : item[column.field]}
                        >
                            {column.field === 'status' ? (
                                getUtilisateurStatusIcon(item[column.field])
                            ) : column.field === 'sexe' ? (
                                item[column.field] === 'madame' ?
                                    <FontAwesomeIcon icon={faFemale} className={`${styles.icone} ${styles.iconeFaFemale}`}/> :
                                    <FontAwesomeIcon icon={faMale} className={`${styles.icone} ${styles.iconeFaMale}`}/>
                            ): (
                                <span>{React.isValidElement(item[column.field]) ? item[column.field] : item[column.field].toString()}</span>
                            )}

                        </div>
                    ))}

                    {expandedRows[index] && (
                        <div className={styles.expandedRow}>
                            {Object.entries(item.details).map(([key, detail], detailIndex) => (
                                <div key={detailIndex} className={styles.detailCell}>
                                    <span className={styles.detailCellKey}>{detail.label} :</span>
                                    <span className={styles.detailCellValue}>{detail.value}</span>
                                </div>
                            ))}

                            {/* Que si ce salarié n'est pas l'utilisateur lui même s */}
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: "10px", marginTop: "10px" }}>
                                {item.id !== user.user.id && (
                                    <button onClick={async (e) => {
                                    // Modal de confirmation avant deleteSalarieByReferent
                                    const modalConfirm = window.confirm("Voulez-vous vraiment supprimer "+ item.name +" ?");
                                    if (modalConfirm) {
                                    const rez = await deleteSalarieByReferent(item.id);
                                        if (rez.success) {
                                            alert("Salarié supprimé avec succès");
                                            // refresh la page
                                            window.location.reload();


                                        } else {
                                            alert("Erreur lors de la suppression du salarié");
                                        }
                                    }
                                }} className={"btn btn_danger"}>Supprimer ce salarié</button>)}

                                <button onClick={async (e) => {
                                    const rez = await getSeancesForSalarie(item.id);
                                    // Display they
                                    setUsersSeances(prev => ({
                                        ...prev,
                                        [item.id]: rez.seances
                                    }));
                                }} className={"btn btn_main"}>Afficher les séances</button>
                            </div>
                            { usersSeances[item.id]?.length > 0 && (
                                <div className={styles.userSeances}>
                                    <h4 style={{ marginBottom: "6px" }}>Ses {usersSeances[item.id]?.length > 20 ? "20" : ""} dernières séances :</h4>
                                    <ul style={{ display: "flex",flexDirection: "column", gap: "4px" }}>
                                        {usersSeances[item.id].map((seance, seanceIndex) => (
                                            <li key={seanceIndex} style={{ display: "flex",flexDirection: "row", gap: "4px" }}>
                                                <span
                                                    style={{
                                                        borderRadius: "50%",
                                                        width: "20px",
                                                        height: "20px",
                                                        backgroundColor: seance.status === 2 ? (seance.presence ? "#48d54f" : "#ff2600") : "#ffe000"
                                                    }}
                                                    title={seance.status === 2 ? (seance.presence ? "Présent" : "Absent") : "Inscrit"}
                                                ></span>
                                                <Link to={Routing.generate({
                                                    route: Routing.routes.seance,
                                                    params: { id: seance.id },
                                                })} className="link">
                                                    {DateService.formatDate(seance.date)} - {seance.titre} :
                                                    <strong> {seance.status === 2 ? (seance.presence ? "Présent" : "Absent") : "Inscrit"}</strong>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            { usersSeances[item.id]?.length === 0 && (
                                <span>Aucune séance</span>
                            )}
                        </div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default GridTabFolding;
